import { pageDto } from './pagedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';
import { ServiceTraductionDto } from './servicetraductiondto';
import { User } from './user';
export class ServiceDto {
    active?: string;
    codeService?: string;
    idService?: number;
    serviceTraductionDto: ServiceTraductionDto[] = [];

    constructor(data?: Partial<ServiceDto>) {
        Object.assign(this, data);
    }
}

export class ServiceResponse {
    listService: ServiceDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class serviceRequest {
    serviceDto: ServiceDto = new ServiceDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}